import {FormGroup, TextField, Button, MenuItem, Select, InputLabel, FormControl, Paper, Typography} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {  useEffect, useState } from "react";
import GetRole from "./user";
import {formatDate2, airportlist} from "./date.js"
import DateCalc from "./date";
import { fetchTrips, fetchLeadsbyNumber, fetchDest, fetchEmployees, fetchLeadbyId, addleadTrip, fetchCustomerbyId, fetchquotedatesonly, updateCustdata } from "../api/customerapi";
import { useAppData } from "./appDataContext.js";
import {preventDoubleClick} from "./preventDC.js"



const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8"
  },
  checkboxalign:{
     alignSelf: "center",
     justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  formgroup: {
      justifyContent: "center",   
  },
  textArea: {
      marginLeft: theme.spacing(12),
      marginRight: theme.spacing(14),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(15),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    
    
  }));

const Leadtripdataentry = () => {

    const classes = useStyles();
    var leadid
    const preURL=document.referrer;
    const urlarray=preURL.split("/");
    const custid=urlarray[urlarray.length-1];

    //const dispatch=useDispatch();
    //const store=useStore();
  
    const [tripData, settripData] =useState(null);

  const [tData, settData]=useState(null);
  const [emp, setemp]=useState([])
  const [leadData, setleadData]=useState({})
  const [dest, setdest]=useState([])
  const [custData, setcustData]=useState([])
  const [followupData, setfollowupData] =useState({
    status: "Open",
    id:1,
    notes:"",
    fuptype:"",
    createdAt:new Date()
});
const airportlist2=airportlist.sort((a, b) => (a.city > b.city) ? 1: -1);
  
  var seven=DateCalc(-7)

  var { cuser, role } = GetRole();
  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  }

const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    //const custdatalistfromdb= data.data

    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    setemp(sortedemp);
    //setemp(empshortname);
}catch(err){
    console.log(err)
  }
  };
   const geteffective=(cr)=>{
    if(cr && cr.length>0){
      var temp=cr.filter(c=>Number(c.outbound_sec)>120)
      if(temp.length>0){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }

  const getLead = async (id) => {
    try{
    const data = await fetchLeadbyId(id);
    setleadData(data.data)
    //console.log(data.data)
    settripData({
        cust_name:data.data.lead_name?data.data.lead_name:"",
        trip_start_date:data.data.lead_travel_date?data.data.lead_travel_date:null,
        start_date_undecided:data.data.lead_travel_date_decided?data.data.lead_travel_date_decided:"",
        primary_destination:data.data.lead_destination?data.data.lead_destination:"",
        primary_mobile_number:data.data.mobile_number?data.data.mobile_number:null,
        primary_email_id:data.data.email_id?data.data.email_id:null,
        number_adults:data.data.lead_pax?Number(data.data.lead_pax):2,
        number_child:data.data.lead_child?Number(data.data.lead_child):0,
        trip_channel:data.data.lead_platform?data.data.lead_platform:"",
        trip_campaign:data.data.lead_campaign?data.data.lead_campaign:"",
        trip_owner:data.data.lead_owner?data.data.lead_owner:"",
        flight_required:data.data.flight_required?data.data.flight_required:false,
        lead_source_airport:data.data.lead_source_airport?data.data.lead_source_airport:"",
        type_of_vacation: "Honeymoon",
        duration: 4,
        trip_stage: "Plan in progress",
        trip_requirements: "",
        multi_destinations: "No",
        lead_details:leadData._id,
      secondary_destinations: "",
      trip_status: "New",
      status_history:[],
      flight_sp:0,
      flight_cp:0,
      land_sp:0,
      land_cp:0,
      anc_sp:0,
      extra_sp:0,
      anc_cp: 0,
      extra_cp:0,
      visa_sp:0,
      visa_cp:0,
      cruise_sp:0,
      cruise_cp:0,
      quote_pending:true,
      quote_pending_time:new Date(),
        follow_up:[{
            status: "Open",
            notes: "",
        }],
        lead:{
            lead_id:data.data.lead_id,
            lead_status:data.data.lead_status,
            lead_budget:data.data.lead_budget,
            lead_campaign:data.data.lead_campaign,
            quality_upgrade:data.data.quality_upgrade,
            lead_source:data.data.lead_source,
            time_to_book:data.data.time_to_book,
            potential:"potential" in data.data?data.data.potential:null,
            effective:geteffective(data.data.callrecord),
            ref_code:data.data.ref_code,
            ref_code_text:data.data.ref_code_text,
            only_whatsapp:"only_whatsapp" in data.data?data.data.only_whatsapp:false,
            initial_quality:"initial_quality" in data.data && data.data.initial_quality?data.data.initial_quality:"",
            customer_type:"customer_type" in data.data && data.data.customer_type?data.data.customer_type:"",
            affiliate_name:"affiliate_name" in data.data && data.data.affiliate_name?data.data.affiliate_name:"",
            fbclid:"fbclid" in data.data && data.data.fbclid?data.data.fbclid:"",
            model_beta:"model_beta" in data.data && data.data.model_beta?data.data.model_beta:"",
            manual_fr:"manual_fast_reach" in data.data && data.data.manual_fast_reach?data.data.manual_fast_reach:"",
        },
    })
}catch(err){
    console.log(err)
  }
  }

  const getCust = async (id) => {
    try{
    const data = await fetchCustomerbyId(id);
    setcustData(data.data)
    console.log(data.data.primary_mobile_number)
    const data2=await fetchLeadsbyNumber(data.data.primary_mobile_number)
    console.log(data2)
    if(data2.data.length==0){
      alert("Unable to find lead with this phone number. Check primary number in customer and lead")
       window.location = ("/home");
    }
    const data3=data2.data.sort((a, b) => {
        return b.lead_id - a.lead_id;
    });
    console.log(data3)
   if(data3.length>0 && (new Date(data3[0].createdAt).getTime()-new Date(seven).getTime())>0){
    getLead(data3[0].lead_id)
   }else{
    alert("Unable to find any recent lead")
    window.location = ("/home");
   }
}catch(err){
    console.log(err)
  }
  }
  
  useEffect(() => {
    //leadid = prompt("Enter lead id for which you want to create trip:");
    getCust(custid)
    getDest()
    getEmployees()
  }, [])

  var fupsomeDate = new Date();
  
  fupsomeDate.setDate(fupsomeDate.getDate()); 
  const fupy=fupsomeDate.getFullYear()
  const fupm=(fupsomeDate.getMonth()+1) < 10? ("0"+(fupsomeDate.getMonth()+1)) : (fupsomeDate.getMonth()+1)
  const fupdt=fupsomeDate.getDate() <10 ? ("0"+fupsomeDate.getDate()) : fupsomeDate.getDate()
  const fupfinalDate=(fupy+"-"+fupm+"-"+fupdt)
  
 // console.log(tripData)
  
  const quotecheck2=async()=>{
    let temp=1
    const today=DateCalc(0)
    for(let i=0;i<tripData.quote.length;i++){
      //console.log(tripData.quote[i])
      const data=await fetchquotedatesonly(tripData.quote[i])
      //console.log(data.data[0])
      // console.log(tripData.quote_pending_time)
      // console.log(new Date(data.data[0].updatedAt).getTime())
      // console.log(new Date(tripData.quote_pending_time).getTime())
      if(data.data.length>0 && new Date(data.data[0].createdAt).getTime()>new Date(today).getTime()){
        temp=0
      }
      if(data.data.length>0 && new Date(data.data[0].updatedAt).getTime()>new Date(today).getTime()){
        temp=0
      }
    }
    //console.log(temp)
    return temp
  }


  const handleSubmit =async (e) => {
    try{
    e.preventDefault();
  
    let qp=0
    // if(followupData.fupautonote=="Quote shared" || followupData.fupautonote=="Asked to add flights. Shared quote with flights" || followupData.fupautonote=="Needed changes. Shared updated quote"){
    //   let ret2=await quotecheck2()
    //   console.log(ret2)
    //   if(ret2){
    //     qp=1
    //   }
    // }
        const finalfollowupData={...followupData, createdby:cuser, new_date:new Date(followupData.date)}
          const finaltripData= {...tripData,cust_id:custid, follow_up:[finalfollowupData],last_updated_by:cuser,createdAt: new Date(), updatedAt: new Date(), quote_pending:qp,
            quote_pending_time: qp ?new Date():null};
          //dispatch(getCustomerbyId(custid));
            console.log(finaltripData);
        const newcustData={...custData, follow_up:{...custData.follow_up, status:"Closed"}}
        
         const updatecustResponse= await updateCustdata(custData._id, newcustData);
         if(cuser=="Munmun"){
         alert("Closed customer: "+updatecustResponse.data.cust_id)
         }
         const addtripResponse= await addleadTrip(finaltripData);
         // dispatch(createCustomer(finalcustData));
         //console.log(addcustResponse.data.cust_id);
         if(addtripResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
           if(updatecustResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
              alert("New trip added with trip id "+addtripResponse.data.trip_id+" || Customer closed: "+updatecustResponse.data.cust_id);
           }else{
              alert("New trip added with trip id "+addtripResponse.data.trip_id+" || No customer closed");
           }
             alert("New trip added with trip id "+addtripResponse.data.trip_id+" || No customer closed");
             window.location = ("/tripdataentry/"+addtripResponse.data.trip_id);
         }
         else{
             alert("Something went wrong. Contact support");
             window.location = ("/");
         }
    
        }catch(err){
            console.log(err)
          }
    }
    
  
  
    return (  
        <div>
        {tripData?(
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Trip {"lead" in tripData && "potential" in tripData.lead?" - "+"Potential:"+tripData.lead.potential:""}</Typography>
            <Typography variant="h6" align="center" className={classes.headertext}> {" ( Customer Id:" + custid+")"}</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select className={classes.textField} labelId="Trip Owner" required value={tripData.trip_owner} disabled={role=="Sales" || role=="SME"?1:0} onChange={(e)=> settripData({...tripData, trip_owner: e.target.value})}>
                <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
                    
                
                </Select>
                </FormControl>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Primary Destination</InputLabel>
                <Select classname={classes.textField} labelId="primary destination" required value={tripData.primary_destination} onChange={(e)=> settripData({...tripData, primary_destination: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                </Select>
                </FormControl>
                <TextField required variant="standard"  type="date" label="Start Date"   inputProps={{ min: fupfinalDate }} InputLabelProps={{ shrink: true }} value={tripData.trip_start_date} className={classes.textField}  onChange={(e)=> settripData({...tripData, trip_start_date: e.target.value})}/>
               
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="multidest">Multiple Destinations?</InputLabel>
                <Select defaultValue="No" classname={classes.textField} labelId="multidest" value={tripData.multi_destinations} onChange={(e)=> settripData({...tripData, multi_destinations: e.target.value})}>
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Secondary Destinations">Secondary Destination</InputLabel>
                <Select disabled={tripData.multi_destinations=="Yes" ? 0 : 1} classname={classes.textField} labelId="Secondary Destinations" value={tripData.secondary_destinations} onChange={(e)=> settripData({...tripData, secondary_destinations: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                </Select>
                </FormControl>
                {/* <TextField variant="standard"  label="Secondary Destinations"  disabled={tripData.multi_destinations=="Yes" ? 0 : 1} value={tripData.secondary_destinations} className={classes.textField} onChange={(e)=> settripData({...tripData, secondary_destinations: e.target.value})}/> */}
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Start date undecided">Start date undecided?</InputLabel>
                <Select defaultValue="No" classname={classes.textField} labelId="Start date undecided" value={tripData.start_date_undecided} onChange={(e)=> settripData({...tripData, start_date_undecided: e.target.value})}>
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Adults"># Adults (number)</InputLabel>
                <Select classname={classes.textField} labelId="Adults" value={tripData.number_adults} onChange={(e)=> settripData({...tripData, number_adults: e.target.value})}>
                    <MenuItem value={1}>1 </MenuItem>
                    <MenuItem value={2}>2 </MenuItem>
                    <MenuItem value={3}>3 </MenuItem>
                    <MenuItem value={4}>4 </MenuItem>
                    <MenuItem value={5}>5 </MenuItem>
                    <MenuItem value={6}>6 </MenuItem>
                    <MenuItem value={7}>7 </MenuItem>
                    <MenuItem value={8}>8 </MenuItem>
                    <MenuItem value={9}>9 </MenuItem>
                    <MenuItem value={10}>10 </MenuItem>
                    <MenuItem value={11}>11 </MenuItem>
                    <MenuItem value={12}>12 </MenuItem>
                    <MenuItem value={13}>13 </MenuItem>
                    <MenuItem value={14}>14 </MenuItem>
                    <MenuItem value={15}>15 </MenuItem>
                    <MenuItem value={16}>16 </MenuItem>
                    <MenuItem value={17}>17 </MenuItem>
                    <MenuItem value={18}>18 </MenuItem>
                    <MenuItem value={19}>19 </MenuItem>
                    <MenuItem value={20}>20 </MenuItem>
                    <MenuItem value={21}>21 </MenuItem>
                    <MenuItem value={22}>22 </MenuItem>
                    <MenuItem value={23}>23 </MenuItem>
                    <MenuItem value={24}>24 </MenuItem>
                    <MenuItem value={25}>25 </MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Child"># Child/Infant (number)</InputLabel>
                <Select classname={classes.textField} labelId="Child" value={tripData.number_child} onChange={(e)=> settripData({...tripData, number_child: e.target.value})}>
                    <MenuItem value={0}>0 </MenuItem>   
                    <MenuItem value={1}>1 </MenuItem>
                    <MenuItem value={2}>2 </MenuItem>
                    <MenuItem value={3}>3 </MenuItem>
                    <MenuItem value={4}>4 </MenuItem>
                    <MenuItem value={5}>5 </MenuItem>
                    <MenuItem value={6}>6 </MenuItem>
                    <MenuItem value={7}>7 </MenuItem>
                    <MenuItem value={8}>8 </MenuItem>
                    <MenuItem value={9}>9 </MenuItem>
                    <MenuItem value={10}>10 </MenuItem>
                    <MenuItem value={11}>11 </MenuItem>
                    <MenuItem value={12}>12 </MenuItem>
                    <MenuItem value={13}>13 </MenuItem>
                    <MenuItem value={14}>14 </MenuItem>
                    <MenuItem value={15}>15 </MenuItem>
                    <MenuItem value={16}>16 </MenuItem>
                    <MenuItem value={17}>17 </MenuItem>
                    <MenuItem value={18}>18 </MenuItem>
                    <MenuItem value={19}>19 </MenuItem>
                    <MenuItem value={20}>20 </MenuItem>
                </Select>
                </FormControl>
            <TextField variant="standard"  label="Total Pax"  value={Number(tripData.number_adults)+Number(tripData.number_child)} className={classes.textField} disabled/>
            <TextField
            required={"number_child" in tripData && tripData.number_child>0?1:0}
            variant="standard"
            label={"Child Age"}
            helperText={"Enter child age separated by commas"}
            InputLabelProps={{ shrink: true }}
            value={tripData.child_age}
            className={classes.textField4}
            onChange={(e) =>
              settripData({ ...tripData, child_age: e.target.value })
            }
          />
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Type of vacation">Type of Vacation</InputLabel>
                <Select classname={classes.textField} labelId="Type of vacation" value={tripData.type_of_vacation} onChange={(e)=> settripData({...tripData, type_of_vacation: e.target.value})}>
                    <MenuItem value={"Honeymoon"}>Honeymoon</MenuItem>
                    <MenuItem value={"Anniversary"}>Anniversary</MenuItem>
                    <MenuItem value={"Birthday"}>Birthday</MenuItem>
                    <MenuItem value={"Break"}>Break</MenuItem>
                    <MenuItem value={"Children-Special"}>Children-Special</MenuItem>
                    <MenuItem value={"Nothing-Special"}>Nothing-Special</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Duration">Duration (number)</InputLabel>
                <Select classname={classes.textField} labelId="Duration" value={tripData.duration} onChange={(e)=> settripData({...tripData, duration: e.target.value})}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Trip Status">Trip Status</InputLabel>
                <Select classname={classes.textField} labelId="Trip Status" value={tripData.trip_status} onChange={(e)=> settripData({...tripData, trip_status: e.target.value})}>
                    <MenuItem value={"New"}>New</MenuItem>
                    <MenuItem value={"Active"}>Active</MenuItem>
                    
                </Select>
                </FormControl>
               
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Channel">Channel *</InputLabel>
                <Select classname={classes.textField} required labelId="Channel" value={tripData.trip_channel} onChange={(e)=> settripData({...tripData, trip_channel: e.target.value})}>
                    <MenuItem value={"Facebook"}>Facebook</MenuItem>
                    <MenuItem value={"Instagram"}>Instagram</MenuItem>
                    <MenuItem value={"TripCrafters"}>TripCrafters</MenuItem>
                    <MenuItem value={"TripClap"}>TripClap</MenuItem>
                    <MenuItem value={"PayTM"}>PayTM</MenuItem>
                    <MenuItem value={"Reference"}>Reference</MenuItem>
                    <MenuItem value={"Tripoto"}>Tripoto</MenuItem>
                    <MenuItem value={"Organic"}>Organic</MenuItem>
                    <MenuItem value={"Email"}>Email</MenuItem>
                    <MenuItem value={"Meta"}>Meta</MenuItem>
                     <MenuItem value={"Poptin"}>Poptin</MenuItem>
                    <MenuItem value={"Manual"}>Manual</MenuItem>
                    <MenuItem value={"Unknown"}>Others</MenuItem>
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Campaign"   value={tripData.trip_campaign} className={classes.textField}  onChange={(e)=> settripData({...tripData, trip_campaign: e.target.value})}/>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Trip Stage">Trip Stage</InputLabel>
                <Select classname={classes.textField} labelId="Trip Stage" value={tripData.trip_stage} onChange={(e)=> settripData({...tripData, trip_stage: e.target.value})}>
                    <MenuItem value={"Flight/Train booked"}>Flight/Train booked</MenuItem>
                    <MenuItem value={"Definitely going"}>Definitely going</MenuItem>
                    <MenuItem value={"Plan in progress"}>Plan in progress</MenuItem>
                    <MenuItem value={"Still dreaming"}>Still dreaming</MenuItem>
                    <MenuItem value={"Looking for info"}>Looking for info</MenuItem>
                   
                </Select>
                </FormControl>
                
               
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
        <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="flightreq">Flight Required?</InputLabel>
            <Select
              classname={classes.textField}
              labelId="flightreq"
              value={tripData.flight_required?true:false}
              onChange={(e)=> settripData({...tripData, flight_required: e.target.value})}
            >
              
              <MenuItem value={false}>false</MenuItem>
              <MenuItem value={true}>true</MenuItem>
            
            </Select>
          </FormControl>
        
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="sourceairport">Source Airport (Airport code only)</InputLabel>
            <Select
              classname={classes.textField}
              displayEmpty
              labelId="sourceairport"
              value={tripData.lead_source_airport}
              required
              onChange={(e)=> settripData({...tripData, lead_source_airport: e.target.value})}
              inputProps={{className: classes.input, pattern:"[A-Z]{3}"}}
              InputLabelProps={{ shrink: true }}
            >
              
              <MenuItem value={"DNK"}>DNK</MenuItem>
              {airportlist2.map(data=>
                    <MenuItem value={data.airport}>{data.airport}</MenuItem>
                  )}
            
            </Select>
          </FormControl>
        </FormGroup>


            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Requirements (shown to customer)"  value={tripData.trip_requirements} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settripData({...tripData, trip_requirements: e.target.value})}/>
            </FormGroup>

            
            <Typography variant="h4" align="center" className={classes.headertext}> Add Followup</Typography>
           
            
            
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Followup Status</InputLabel>
                <Select defaultValue="Open" disabled className={classes.textField} labelId="status" required onChange={(e)=> setfollowupData({...followupData, status: e.target.value})}>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>  
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="fuptype">Followup Type</InputLabel>
                <Select  className={classes.textField} labelId="fuptype" required onChange={(e)=> setfollowupData({...followupData, fuptype: e.target.value})}>
                    <MenuItem value={"Share first quote"}>Share first quote</MenuItem>
                    <MenuItem value={"Share revised quote"}>Share revised quote</MenuItem>
                    <MenuItem value={"Quote feedback"}>Quote feedback</MenuItem>
                    <MenuItem value={"Ask for payment"}>Ask for payment</MenuItem>
                    <MenuItem value={"Voucher or Confirmation pending"}>Voucher or Confirmation pending</MenuItem> 
                    <MenuItem value={"Trip Feedback"}>Trip Feedback</MenuItem> 
                    <MenuItem value={"Others"}>Others</MenuItem> 
                    
                
                </Select>
                </FormControl>
                </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  type="date" label="Followup Date"   inputProps={{ min: fupfinalDate }} required className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, date: e.target.value})}/>
                <TextField variant="standard"  type="time" label="Followup Time"   required className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, time: e.target.value})} />
               
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="fupautonote">Canned Notes</InputLabel>
            <Select
              className={classes.textField}
              labelId="fupautonote"
              required={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?0:1}
              onChange={(e) =>
                setfollowupData({
                  ...followupData,
                  fupautonote: e.target.value,
                  notes: e.target.value,
                })
              }
            >
            <MenuItem value={"Call not picked"}>Call not picked</MenuItem>
            <MenuItem value={"Call not picked. WA sent"}>Call not picked. WA sent</MenuItem>
              <MenuItem value={"Call not picked and no response on Whatsapp"}>
                Call not picked and no response on Whatsapp
              </MenuItem>
              <MenuItem value={"Need to share first quote"}>Need to share first quote</MenuItem>
              <MenuItem
                value={"Asked to add flights. Shared quote with flights"}
              >
                Asked to add flights. Shared quote with flights
              </MenuItem>
              {/* <MenuItem value={"Fup done manually"}>Fup done manually</MenuItem> */}
              <MenuItem value={"Quote shared"}>Quote shared</MenuItem>
              <MenuItem value={"Yet to view quote"}>Yet to view quote</MenuItem>
              <MenuItem value={"Need changes. Need to share updated quote"}>
                Need changes. Need to share updated quote
              </MenuItem>
              <MenuItem value={"Needed changes. Shared updated quote"}>
                Needed changes. Shared updated quote
              </MenuItem>
              <MenuItem value={"Will let you know tomorrow"}>
                Will let you know tomorrow
              </MenuItem>
              <MenuItem value={"Will let you know"}>
                Will let you know
              </MenuItem>
              <MenuItem value={"Will let you know within 2-3 days"}>
                Will let you know within 2-3 days
              </MenuItem>
              <MenuItem value={"Will let you know within a week"}>
                Will let you know within a week
              </MenuItem>
              <MenuItem value={"Asked to call later"}>
                Asked to call later
              </MenuItem>
              <MenuItem value={"Asked to call later after a few days"}>
                Asked to call later after a few days
              </MenuItem>
              <MenuItem value={"Asked to call later after a week"}>
                Asked to call later after a week
              </MenuItem>
              <MenuItem value={"Our quote is costly. Shared other options"}>
                Our quote is costly. Shared other options
              </MenuItem>
              <MenuItem value={"Budget issue. Will let us know"}>
                Budget issue. Will let us know
              </MenuItem>
              <MenuItem value={"Budget issue. Shared other options"}>
                Budget issue. Shared other options
              </MenuItem>
              <MenuItem value={"Comparing packages with other agencies"}>
                Comparing packages with other agencies
              </MenuItem>
              <MenuItem value={"Okay with package. Will tell the final decision"}>
              Okay with package. Will tell the final decision
              </MenuItem>
              <MenuItem value={"Plan on hold"}>Plan on hold</MenuItem>
              <MenuItem value={"No response after multiple follow ups"}>
                No response after multiple follow ups
              </MenuItem>
              <MenuItem value={"Will call you back if we are interested"}>
                Will call you back if we are interested
              </MenuItem>
              <MenuItem value={"Everything finalized. Awaiting payment"}>
                Everything finalized. Awaiting payment
              </MenuItem>
              {/* <MenuItem value={"Asked to cancel-on call"}>
                Asked to cancel-on call
              </MenuItem>
              <MenuItem value={"Asked to cancel-on whatsapp"}>
                Asked to cancel-on whatsapp
              </MenuItem> */}
              <MenuItem value={"Manual Cancellation"}>
                Manual Cancellation
              </MenuItem>
              <MenuItem value={"Booked Outside"}>
                Booked Outside
              </MenuItem>
              <MenuItem value={"Asked to postpone"}>
                Asked to postpone
              </MenuItem>
              <MenuItem value={"Plan on hold"}>
                Plan on hold
              </MenuItem>
              <MenuItem value={"Need to share voucher or tickets"}>
                Need to share voucher or tickets
              </MenuItem>
              <MenuItem value={"Need to share insurance"}>
                Need to share insurance
              </MenuItem>
              <MenuItem value={"Need to confirm booking with supplier"}>
                Need to confirm booking with supplier
              </MenuItem>
              <MenuItem value={"Need to make payment to supplier"}>
                Need to make payment to supplier
              </MenuItem>
              <MenuItem value={"Data entry only"}>
                Data entry only
              </MenuItem>
              <MenuItem value={"Call not needed. Msg dropped"}>
              Call not needed. Msg dropped
              </MenuItem>
              
            </Select>
          </FormControl>
        </FormGroup>

            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Notes"  className={classes.textArea} value={followupData.notes}  fullWidth multiline rows={2} onChange={(e)=> setfollowupData({...followupData, notes: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary"  onClick={preventDoubleClick(handleSubmit)} className={classes.button}>Save</Button>
                <Button href={"/custdataentry/"+custid} variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                
            </FormGroup>
              
            </form>
                                            
                        
            </Paper>
        ):("Loading...")}
        </div>
    );

   
}
 
export default Leadtripdataentry;

